import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";

import FormField from "@/components/atoms/FormField";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import { CampaignFormData } from "@/components/screens/CampaignFormPage/types";
import { CampaignFormMessages } from "@/messages/campaigns/campaign-form.messages";

type Props = {
  messages: CampaignFormMessages;
};

const Introduction = ({ messages }: Props) => {
  const { values, handleChange, errors } = useFormikContext<CampaignFormData>();

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={3}>
        <MDBox display="flex" justifyContent="space-between">
          <MDTypography variant="h5" fontWeight="bold">
            {messages.introductionTitle}
          </MDTypography>
        </MDBox>

        <MDBox mt={1}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <FormField
                externalLabel
                variant="outlined"
                name="text"
                label={messages.introductionTextLabel}
                value={values.text ? values.text.replace(/\\n/g, "\n") : ""}
                onChange={handleChange}
                fullWidth
                multiline
                rows={6}
                InputProps={{ readOnly: true }}
                error={!!errors.text}
              />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
    </Card>
  );
};

export default Introduction;
